import { render, staticRenderFns } from "./iconTwitter.vue?vue&type=template&id=b6084f3a&scoped=true"
import script from "./iconTwitter.vue?vue&type=script&lang=js"
export * from "./iconTwitter.vue?vue&type=script&lang=js"
import style0 from "./iconTwitter.vue?vue&type=style&index=0&id=b6084f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6084f3a",
  null
  
)

export default component.exports